import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import {
  getSingleEmployee,
  updateEmployeeRoles,
  updateEmployee,
  startRetryUpdateUser,
  startRetryUpdateEmployee,
} from '../../redux/actions/employee';
import {
  createNewEmployee,
  startRetryUser,
  startRetryEmployee,
  updateSubmitModalOpen,
  updateSubmitModalFinishOpen,
  showRollbackModal,
  cancelRollbackModal,
  rollbackFinish,
  startRollbackUser,
  updateSubmitModalErrorOpen,
  resetSubmitModal,
  updateCreateNewCompanyStep,
} from '../../redux/actions/company';
import {
  getRolesByUserId,
  updateInitialUserRoles,
} from '../../redux/actions/user';
import EmployeeRegisterPage from './EmployeeRegister.page';

const mapStateToProps = state => ({
  employeeDetails: state.organization.detailEmployee,
  me: state.auth.me,
  submitModalOpen: state.organization.submitModalOpen,
  submitAddCompanyState: state.organization.submitAddCompanyState,
  submitAddUserState: state.organization.submitAddUserState,
  submitAddEmployeeState: state.organization.submitAddEmployeeState,
  submitModalFinishOpen: state.organization.submitModalFinishOpen,
  submitModalErrorOpen: state.organization.submitModalErrorOpen,
  createNewCompanyStep: state.organization.createNewCompanyStep,
  createNewCompanyParams: state.organization.createNewCompanyParams,
  rollbackModalOpen: state.organization.rollbackModalOpen,
  rollbackModalFinishOpen: state.organization.rollbackModalFinishOpen,
  isRollbackSuccess: state.organization.isRollbackSuccess,
  initialUserRoles: state.organization.initialUserRoles,
  loadingInitialUserRoles: state.organization.loadingInitialUserRoles,
});

const mapDispatchToProps = {
  getSingleEmployee,
  updateEmployeeRoles,
  updateEmployee,
  createNewEmployee,
  startRetryUser,
  startRetryEmployee,
  updateSubmitModalOpen,
  updateSubmitModalFinishOpen,
  showRollbackModal,
  cancelRollbackModal,
  rollbackFinish,
  startRollbackUser,
  startRetryUpdateUser,
  startRetryUpdateEmployee,
  updateSubmitModalErrorOpen,
  getRolesByUserId,
  resetSubmitModal,
  updateCreateNewCompanyStep,
  updateInitialUserRoles,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(EmployeeRegisterPage));
